/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';

import DateFnsUtils from '@date-io/date-fns';
import {
  Tooltip,
  Typography,
  FormControlLabel,
  Popover,
  TextField,
  useMediaQuery,
  Grid,
  FormControl,
  Radio,
  IconButton
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import ptLocale from 'date-fns/locale/pt-BR';
import moment from 'moment/moment';

import Button from 'components/Button/button';
import ImageWrapper from 'components/ImageWrapper';
import CalendarIcon from 'images/icons/objects/calendars/calendarNavyBlueOutline.svg';
import CloseIcon from 'images/icons/signals/closesAndCancels/closeModal.svg';
import ValidationLength from 'utils/utils';
import GenerateHashId from 'utils/geneareteHashId';
import ClockRoundedIcon from 'images/icons/objects/clocks/clockRoundedIcon';
import PrinterRoundedIcon from 'images/icons/objects/printers/printerRoundedIcon';
import PlusRoundedIcon from 'images/icons/signals/addsAndCreates/PlusRoundedIcon';
import MinusRoundedIcon from 'images/icons/signals/removesAndDeletes/minusRoundedIcon';

function ProductionPopovers({
  setManufacture,
  manufacture,
  setManufactures,
  manufactures,
  id,
  popoverOpen,
  anchorEl,
  handleClose,
  productionInputControlPopoverOpen,
  productionInputControlAnchor,
  popoverData,
  cardDate,
  setCardDate,
  currentTransformationCardItems,
  setCurrentTransformationCardItems,
  parametersInfos,
  disableSubmitButton,
  setDisableSubmitButton,
  handleUpdate,
  setModalStates,
  modalStates,
  setModalSettings,
  modalSettings,
  setShowErrorManufacturedMessage,
  setUpdatedManufacture,
  updatedManufacture,
  showErrorManufacturedMessage,
  setProductionInputControlAnchor,
  setCurrentCard,
  currentCard,
  handleUpdateViewMethod,
  handlePrintPortion,
  loading,
  userInfo
}) {
  const isMobileScreen = useMediaQuery('(max-width: 821px)');
  const DATE_FORMAT = 'DD/MM/YYYY';
  const isTransformation = manufacture?.type === 'TRANSFORMATION';
  const isFinished = manufacture?.status === 'FINISH';
  const isChinaWhiteLabel = userInfo?.whiteLabel === 'CHINA';
  const currentLabelColor = isChinaWhiteLabel ? '#E1392E' : '#5062F0';
  const calendarButtonRef = useRef(null);
  const enabledInputRefs = useRef([]);
  const enabledTransformationItemsInputRefs = useRef([]);
  const [
    transformationItemPortionsAnchor,
    setTransformationItemPortionsAnchor
  ] = useState(null);
  const [currentTransformationItem, setCurrentTransformationItem] =
    useState(null);
  const [hasChanged, setHasChanged] = useState(false);
  const transformationItemPortionPopoverOpen = Boolean(
    transformationItemPortionsAnchor
  );
  const isPrintEnabled = parametersInfos?.manufactures?.isPrintEnabled;

  useEffect(() => {
    if (!popoverOpen || transformationItemPortionPopoverOpen) return;

    let observer: MutationObserver | null = null;

    const tryFocus = () => {
      const inputs = enabledInputRefs.current.filter(
        (el) => el && !el.disabled
      );

      if (inputs.length === 0) return;

      const inputWithValue = [...inputs].reverse().find((el) => {
        const val = el.value || el.getAttribute('value');
        return val && val.trim() !== '';
      });

      let target: HTMLInputElement | undefined;

      if (inputWithValue) {
        target = inputWithValue;
      } else {
        target =
          inputs.find((el) => {
            const val = el.value || el.getAttribute('value');
            return !val || val.trim() === '';
          }) || inputs[0];
      }

      if (target) {
        target.focus({ preventScroll: true });
        target.select();
      }
    };

    observer = new MutationObserver(() => {
      tryFocus();
    });

    const container = document.getElementById(id);
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }

    const timeout = setTimeout(() => {
      tryFocus();
    }, 150);

    return () => {
      observer?.disconnect();
      clearTimeout(timeout);
    };
  }, [popoverOpen, transformationItemPortionPopoverOpen]);

  useEffect(() => {
    if (!transformationItemPortionPopoverOpen) return;

    let observer: MutationObserver | null = null;

    const tryFocus = () => {
      const inputs = enabledTransformationItemsInputRefs.current.filter(
        (el) => el && !el.disabled
      );

      if (inputs.length === 0) return;

      const inputWithValue = [...inputs]
        .reverse()
        .find((el) => el.value && el.value.trim() !== '');

      let target: HTMLInputElement | undefined;

      if (inputWithValue) {
        target = inputWithValue;
      } else {
        target =
          inputs.find((el) => {
            const val = el.value || el.getAttribute('value');
            return !val || val.trim() === '';
          }) || inputs[0];
      }

      if (target) {
        target.focus();
        target.select();
      }
    };

    observer = new MutationObserver(() => {
      tryFocus();
    });

    const container = document.getElementById(
      'transformationItemPortionsPopover'
    );

    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }

    const timeout = setTimeout(() => {
      tryFocus();
    }, 150);

    return () => {
      observer?.disconnect();
      clearTimeout(timeout);
    };
  }, [transformationItemPortionPopoverOpen, popoverData]);

  const isOutOfValidPercentage = () => {
    const total = currentTransformationCardItems?.items?.reduce(
      (total, value) =>
        value
          ? parseFloat(total) + parseFloat(value.quantity || 0)
          : parseFloat(total),
      0
    );
    const cardLostTotal =
      parseFloat(currentTransformationCardItems?.yield || 0) -
      parseFloat(total);

    return {
      invalid:
        parseFloat(100 * Math.abs(cardLostTotal)) /
          parseFloat(manufacture?.yield) >
          parseFloat(parametersInfos?.manufactures?.percentageForAlert) &&
        currentTransformationCardItems?.items?.some((el) => el?.quantity),
      diffPercentage:
        parseFloat(100 * Math.abs(cardLostTotal)) /
          parseFloat(manufacture?.yield) -
        parseFloat(parametersInfos?.manufactures?.percentageForAlert)
    };
  };

  const renderTransformationItemPortionsPopover = () => {
    const syncUpdatedPortions = (updatedPortions) => {
      const itemSum = updatedPortions.reduce(
        (sum, p) => sum + (p.quantity || 0),
        0
      );
      const itemLabel = itemSum.toFixed(3).replace('.', ',');

      const updatedItem = {
        ...currentTransformationItem,
        portions: updatedPortions,
        quantity: itemSum,
        labelQuantity: itemLabel,
        manufactured: itemSum,
        manufacturedLabel: itemLabel
      };

      const updatedItems = manufacture.items.map((item) =>
        item.id === currentTransformationItem.id ? updatedItem : item
      );

      const totalManufactured = updatedItems.reduce((acc, item) => {
        const sumItem =
          item.portions?.reduce((sum, p) => sum + (p.quantity || 0), 0) || 0;
        return acc + sumItem;
      }, 0);

      const formattedLabel = totalManufactured.toFixed(3).replace('.', ',');

      setCurrentTransformationItem(updatedItem);
      setCurrentTransformationCardItems({
        ...currentTransformationCardItems,
        items: updatedItems
      });
      setManufacture({
        ...manufacture,
        items: updatedItems,
        manufactured: totalManufactured,
        manufacturedLabel: formattedLabel
      });
    };

    const handleAddPortion = (portion, index) => {
      setHasChanged(true);

      if (!portion?.labelQuantity) {
        const updatedPortions =
          currentTransformationItem.portions?.map((p, i) =>
            i === index ? { ...p, invalidField: true } : p
          ) ?? [];

        syncUpdatedPortions(updatedPortions);
        return;
      }

      const hashId = GenerateHashId();
      const newPortions = [
        ...currentTransformationItem.portions,
        {
          quantity: '',
          labelQuantity: '',
          printed: false,
          fakeKey: crypto.randomUUID(),
          id: hashId
        }
      ];

      syncUpdatedPortions(newPortions);

      setTimeout(() => {
        const lastRefList = enabledTransformationItemsInputRefs.current;
        const lastRef = lastRefList?.[lastRefList.length - 1];
        if (lastRef) {
          lastRef.focus();
          lastRef.select();
        }
      }, 50);
    };

    const handleRemovePortion = (index) => {
      setHasChanged(true);

      const updatedPortions =
        currentTransformationItem.portions?.filter((_, i) => i !== index) ?? [];

      syncUpdatedPortions(updatedPortions);

      setTimeout(() => {
        const refList = enabledTransformationItemsInputRefs.current;

        refList.forEach((ref, i) => {
          if (
            ref &&
            updatedPortions[i] &&
            updatedPortions[i].quantity == null
          ) {
            ref.value = '';
          }
        });

        const lastRef = [...refList].reverse().find((el) => el && !el.disabled);
        if (lastRef) {
          lastRef.focus();
          lastRef.select();
        }
      }, 0);
    };

    enabledTransformationItemsInputRefs.current = [];

    return (
      <Popover
        id="transformationItemPortionsPopover"
        open={transformationItemPortionPopoverOpen}
        anchorEl={transformationItemPortionsAnchor}
        onClose={() => {
          setTransformationItemPortionsAnchor(null);
          setCurrentTransformationItem(null);
        }}
        className={`productionPopover ${
          isChinaWhiteLabel && 'chinaProductionPopover'
        }`}
        PaperProps={{
          style: {
            padding: '10px',
            borderRadius: '4px',
            maxWidth: isMobileScreen ? '600px' : '400px'
          }
        }}
        anchorOrigin={{
          vertical: isMobileScreen ? 'center' : 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <section className="finishPopoverBox">
          <div className="popoverHeader">
            <div className="productionImageBox">
              <ImageWrapper
                width="100%"
                height="40px"
                url={currentTransformationItem?.image}
                borderType={currentTransformationItem?.type}
              />
            </div>

            <div className="cardTitleBox dFlex flexColumn">
              <span className="uppercase bold productionDescription">
                {ValidationLength(
                  currentTransformationItem?.item || null,
                  isMobileScreen ? 40 : 35
                )}
              </span>
            </div>

            <IconButton
              onClick={() => {
                setTransformationItemPortionsAnchor(null);
                setCurrentTransformationItem(null);
              }}
              className="p0"
              style={{ outline: '0', background: 'none', align: 'right' }}
            >
              <img style={{ width: '16px' }} src={CloseIcon} alt="CloseIcon" />
            </IconButton>
          </div>

          <div className="popoverContent">
            {currentTransformationItem?.portions?.map((portion, index) => {
              const isLastItem =
                index === currentTransformationItem.portions.length - 1;

              return (
                <>
                  <div
                    className={`defaultItem transformationItemsPortions dFlex alignCenter justifyCenter ${
                      portion?.invalidField ? 'invalidField' : ''
                    } ${!isPrintEnabled && 'disablePrintActions'}`}
                    key={index}
                  >
                    <span className="dFlex alignCenter justifyEnd labelItem">
                      QTDE PRODUZIDA {index + 1}
                    </span>

                    <div className="itemActions">
                      <div className="portionQuantityBox">
                        <TextField
                          id="popupCardYield"
                          inputRef={(el) => {
                            if (el)
                              enabledTransformationItemsInputRefs.current[
                                index
                              ] = el;
                          }}
                          className={`textFieldSmall right childInputP0 childInputW100 ${
                            isMobileScreen
                              ? 'childInputFontSize20'
                              : 'childInputFontSize16'
                          }`}
                          placeholder="Digite aqui..."
                          variant="outlined"
                          fullWidth
                          disabled={isFinished}
                          type="text"
                          value={portion?.labelQuantity}
                          inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            maxLength: 15
                          }}
                          onKeyDown={(e) => {
                            if (['Tab', 'Enter'].includes(e.key)) {
                              const val = e.currentTarget.value;
                              if (!val || val === '0' || val === '0.000') {
                                setShowErrorManufacturedMessage(true);
                                setManufactures(manufactures);
                                return;
                              }
                              e.currentTarget.blur();
                            }
                          }}
                          onChange={(e) => {
                            setHasChanged(true);

                            const raw = e.target.value.replace(/\D/g, '');
                            const padded = raw.padStart(4, '0');
                            const integerPart = padded.slice(0, -3);
                            const decimalPart = padded.slice(-3);
                            const numeric = parseFloat(
                              `${parseInt(integerPart, 10)}.${decimalPart}`
                            );
                            const label = numeric.toFixed(3).replace('.', ',');
                            const hashId = GenerateHashId();

                            const updatedPortions =
                              currentTransformationItem.portions?.map((el, i) =>
                                i === index
                                  ? {
                                      ...el,
                                      quantity: numeric,
                                      labelQuantity: label,
                                      invalidField: false,
                                      printed: false,
                                      id: hashId
                                    }
                                  : el
                              );

                            syncUpdatedPortions(updatedPortions);
                          }}
                          onBlur={(e) => {
                            const value = e.target.value.replace(',', '.');
                            const parsed = parseFloat(value);

                            if (!parsed || parsed === 0) {
                              const updatedPortions =
                                currentTransformationItem.portions?.map(
                                  (el, i) =>
                                    i === index
                                      ? {
                                          ...el,
                                          quantity: null,
                                          labelQuantity: null
                                        }
                                      : el
                                );
                              syncUpdatedPortions(updatedPortions);
                              return;
                            }

                            const label = parsed.toFixed(3).replace('.', ',');

                            const updatedPortions =
                              currentTransformationItem.portions?.map((el, i) =>
                                i === index
                                  ? {
                                      ...el,
                                      quantity: parsed,
                                      labelQuantity: label
                                    }
                                  : el
                              );

                            syncUpdatedPortions(updatedPortions);
                          }}
                        />

                        <span className="unit mt0 mr0 mb5 ml5">
                          {currentTransformationItem?.un?.abbreviation}
                        </span>
                      </div>

                      <div
                        className={`addOrRemoveItemBox ${
                          !isPrintEnabled && 'dNone'
                        }`}
                      >
                        {isLastItem ? (
                          <PlusRoundedIcon
                            onClick={() => {
                              if (isFinished) return;
                              handleAddPortion(portion, index);
                            }}
                            className="switchIcon cursorPointer"
                            size={40}
                            variant="solid"
                            bgColor={isChinaWhiteLabel ? '#E1392EB2' : '#7583F0'}
                            title="Adicionar porção"
                          />
                        ) : (
                          <MinusRoundedIcon
                            onClick={() => {
                              if (isFinished) return;
                              handleRemovePortion(index);
                            }}
                            className="switchIcon cursorPointer"
                            size={40}
                            variant="solid"
                            title="Remover porção"
                            bgColor={isChinaWhiteLabel ? '#E5AD5C' : '#F76E79'}
                          />
                        )}
                      </div>

                      <div
                        className={`printerBox ${!isPrintEnabled && 'dNone'} ${
                          !portion?.printed && 'visibilityHidden'
                        }`}
                      >
                        <PrinterRoundedIcon
                          onClick={() => {
                            if (loading) return;
                            handlePrintPortion(manufacture, '', [
                              {
                                ...portion,
                                itemDescription: currentTransformationItem?.item
                              }
                            ]);
                          }}
                          className="switchIcon cursorPointer"
                          size={40}
                          variant={portion?.printed ? 'primary' : 'muted'}
                          bgColor={
                            portion?.printed ? currentLabelColor : undefined
                          }
                          strokeColor={portion?.printed ? '#010311' : undefined}
                          title={
                            portion?.printed
                              ? 'Imprimir etiqueta'
                              : 'Impressão indisponível'
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {!isLastItem &&
                  currentTransformationItem?.portions?.length > 1 ? (
                    <hr
                      style={{
                        borderTop: 'solid 1px rgba(146, 150, 172, 1)',
                        margin: '10px -10px'
                      }}
                    />
                  ) : null}
                </>
              );
            })}
          </div>
        </section>
      </Popover>
    );
  };

  const renderFinishTransformationPopover = () => {
    const updateManufacture = (newItems) => {
      const totalSum = newItems.reduce((acc, item) => {
        const itemSum = item.portions.reduce(
          (sumAcc, portion) => sumAcc + (portion.quantity || 0),
          0
        );
        return acc + itemSum;
      }, 0);

      setManufacture((prev) => ({
        ...prev,
        items: newItems,
        manufactured: totalSum,
        manufacturedLabel: totalSum?.toFixed(3).replace('.', ',')
      }));
    };

    enabledInputRefs.current = [];

    return manufacture.items.map((item, index) => {
      const portions = item.portions || [];
      const filledPortions = portions.filter((p) => p.quantity);
      const hasMultipleFilledPortions = filledPortions.length > 1;
      const disableInput = hasMultipleFilledPortions;
      const currentItem = currentTransformationCardItems?.items?.[index];
      const isLastItem = index === manufacture?.items?.length - 1;
      const hidePrinterButton =
        !item?.portions?.length ||
        !item?.portions?.every((portion) => portion?.printed);
      const sumPortions = filledPortions.reduce(
        (acc, p) => acc + (p.quantity ?? 0),
        0
      );
      const displayValue = disableInput
        ? sumPortions.toFixed(3).replace('.', ',')
        : currentItem?.labelQuantity || '';

      const allPrinted =
        item?.portions?.length &&
        item?.portions?.every((portion) => portion?.printed);

      return (
        <>
          <div
            className={`defaultItem dFlex alignStretch justifyCenter ${
              !isPrintEnabled && 'disablePrintActions'
            }`}
            key={item.id || index}
          >
            <div className="itemInfosBox dFlex alignCenter">
              <div className="itemImageBox">
                <ImageWrapper
                  width="100%"
                  height="40px"
                  url={item?.image}
                  borderType={item?.type}
                />
              </div>

              <div className="itemDescription">
                {ValidationLength(item.item, isMobileScreen ? 40 : 25)}
                {item.suggestionYield
                  ? `(${item.suggestionYield.toLocaleString('pt-br', {
                      minimumFractionDigits: 3
                    })}${item?.un?.abbreviation})`
                  : null}
              </div>
            </div>

            <div className="itemActions transformationItemActions">
              <div className="portionQuantityBox">
                <TextField
                  id={`popupInternalItem-${index}`}
                  inputRef={(el) => {
                    if (el) enabledInputRefs.current[index] = el;
                  }}
                  className={`textFieldSmall right mt10 childInputP0 childInputW100 ${
                    isMobileScreen
                      ? 'childInputFontSize20'
                      : 'childInputFontSize16'
                  }`}
                  placeholder="Digite aqui..."
                  variant="outlined"
                  fullWidth
                  value={displayValue}
                  disabled={disableInput || isFinished}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    maxLength: 15
                  }}
                  onChange={(e) => {
                    if (disableInput) return;

                    const raw = e.target.value.replace(/\D/g, '');
                    const padded = raw.padStart(4, '0');
                    const integerPart = padded.slice(0, -3);
                    const decimalPart = padded.slice(-3);

                    const formatted = `${parseInt(
                      integerPart,
                      10
                    )}.${decimalPart}`;
                    const quantity = parseFloat(formatted);
                    const label = quantity.toFixed(3).replace('.', ',');

                    setHasChanged(true);

                    setCurrentTransformationCardItems((prev) => {
                      const hashId = GenerateHashId();

                      const newItems = prev.items.map((el, elIndex) =>
                        elIndex === index
                          ? {
                              ...el,
                              quantity,
                              labelQuantity: label,
                              portions: [
                                {
                                  ...(el.portions?.[0] || {}),
                                  quantity,
                                  labelQuantity: label,
                                  printed: false,
                                  id: hashId
                                },
                                ...(el.portions?.slice(1) || [])
                              ]
                            }
                          : el
                      );
                      updateManufacture(newItems);
                      return { ...prev, items: newItems };
                    });
                  }}
                />

                <span className="unit mt5 mr0 mb0 ml5">
                  {item?.un?.abbreviation}
                </span>
              </div>

              <div
                className={`hasOrNotPortionsBox ${!isPrintEnabled && 'dNone'}`}
              >
                {filledPortions?.length > 1 && (
                  <span className="itemPortionsCount">
                    {filledPortions.length}
                  </span>
                )}

                <ClockRoundedIcon
                  onClick={(event) => {
                    const updatedItem = manufacture.items.find(
                      (i) => i.id === item.id
                    );
                    const hashId = GenerateHashId();

                    setCurrentTransformationItem({
                      ...updatedItem,
                      description: updatedItem?.item,
                      portions: updatedItem?.portions?.length
                        ? updatedItem?.portions
                        : [
                            {
                              quantity: '',
                              labelQuantity: '',
                              printed: false,
                              id: hashId
                            }
                          ]
                    });
                    setTransformationItemPortionsAnchor(event.currentTarget);
                  }}
                  className="switchIcon cursorPointer"
                  variant={filledPortions?.length > 1 ? 'solid' : 'outline'}
                  bgColor={currentLabelColor}
                  frameColor={currentLabelColor}
                  baseFill="#FFFFFF"
                  baseStroke={
                    filledPortions?.length > 1 ? '#010311' : currentLabelColor
                  }
                  wedgeFill={filledPortions?.length > 1 ? '#F2B90D' : '#D0D3E2'}
                  wedgeStroke={
                    filledPortions?.length > 1 ? '#010311' : currentLabelColor
                  }
                  strokeWidth={1}
                />
              </div>

              <div
                className={`printerBox ${!isPrintEnabled && 'dNone'} ${
                  hidePrinterButton && 'visibilityHidden'
                }`}
              >
                <PrinterRoundedIcon
                  onClick={() => {
                    if (loading) return;
                    handlePrintPortion(
                      manufacture,
                      '',
                      item?.portions?.map((el) => ({
                        ...el,
                        itemDescription: item?.item
                      }))
                    );
                  }}
                  className="switchIcon cursorPointer"
                  size={40}
                  variant={allPrinted ? 'primary' : 'muted'}
                  bgColor={allPrinted ? currentLabelColor : undefined}
                  strokeColor={allPrinted ? '#010311' : undefined}
                  title={
                    allPrinted ? 'Imprimir etiquetas' : 'Impressão indisponível'
                  }
                />
              </div>
            </div>
          </div>

          {!isLastItem && manufacture.items?.length > 1 ? (
            <hr
              style={{
                borderTop: 'solid 1px rgba(146, 150, 172, 1)',
                margin: '10px -10px'
              }}
            />
          ) : null}
        </>
      );
    });
  };

  const renderFinishRecipePopover = () =>
    manufacture?.portions?.map((portion, index) => {
      const isLastItem = index === manufacture?.portions?.length - 1;
      const hasMoreThanOneItem = manufacture?.portions?.length > 1;
      enabledInputRefs.current = [];

      return (
        <>
          <div
            key={`portion${index}`}
            className={`defaultItem recipePortionItem dFlex alignCenter justifyCenter ${
              portion?.invalidField ? 'invalidField' : ''
            } ${!isPrintEnabled && 'disablePrintActions'}`}
          >
            <span className="dFlex alignCenter justifyEnd labelItem">
              QTDE PRODUZIDA {hasMoreThanOneItem ? index + 1 : ''}
            </span>

            <div className="itemActions">
              <div className="portionQuantityBox">
                <TextField
                  key={`inputRecipe-${portion?.fakeKey}`}
                  id="popupCardYield"
                  inputRef={(el) => {
                    if (el) enabledInputRefs.current[index] = el;
                  }}
                  className={`textFieldSmall right childInputP0 childInputW100 ${
                    isMobileScreen
                      ? 'childInputFontSize20'
                      : 'childInputFontSize16'
                  }`}
                  disabled={isFinished}
                  placeholder="Digite aqui..."
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={portion?.labelQuantity}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    maxLength: 15
                  }}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/\D/g, '');
                    const padded = raw.padStart(4, '0');
                    const integerPart = padded.slice(0, -3);
                    const decimalPart = padded.slice(-3);
                    const formattedStr = `${parseInt(
                      integerPart,
                      10
                    )}.${decimalPart}`;
                    const quantity = parseFloat(formattedStr);
                    const label = quantity.toFixed(3).replace('.', ',');

                    setHasChanged(true);

                    const hashId = GenerateHashId();
                    const updatedPortions = manufacture?.portions?.map(
                      (el, elIndex) =>
                        elIndex === index
                          ? {
                              ...el,
                              quantity,
                              labelQuantity: label,
                              invalidField: false,
                              printed: false,
                              id: hashId
                            }
                          : el
                    );

                    const totalManufactured = updatedPortions.reduce(
                      (acc, curr) => acc + (curr.quantity ?? 0),
                      0
                    );

                    setManufacture({
                      ...manufacture,
                      portions: updatedPortions,
                      manufactured: totalManufactured,
                      manufacturedLabel: totalManufactured
                        .toFixed(3)
                        .replace('.', ',')
                    });

                    setUpdatedManufacture(quantity);
                  }}
                  onBlur={(e) => {
                    const value = e.target.value.replace(',', '.');
                    const parsed = parseFloat(value);
                    const valid = !isNaN(parsed) && parsed > 0;

                    if (!valid) {
                      const resetPortions = manufacture?.portions?.map(
                        (el, elIndex) =>
                          elIndex === index
                            ? { ...el, quantity: null, labelQuantity: null }
                            : el
                      );
                      setManufacture({
                        ...manufacture,
                        portions: resetPortions
                      });
                      return;
                    }

                    const label = parsed.toFixed(3).replace('.', ',');

                    const updatedPortions = manufacture?.portions?.map(
                      (el, elIndex) =>
                        elIndex === index
                          ? {
                              ...el,
                              quantity: parsed,
                              labelQuantity: label
                            }
                          : el
                    );

                    const totalManufactured = updatedPortions.reduce(
                      (acc, curr) => acc + (curr.quantity ?? 0),
                      0
                    );

                    setManufacture({
                      ...manufacture,
                      portions: updatedPortions,
                      manufactured: totalManufactured,
                      manufacturedLabel: totalManufactured
                        .toFixed(3)
                        .replace('.', ',')
                    });

                    setUpdatedManufacture(parsed);
                  }}
                />

                <span className="unit mt0 mr0 mb5 ml5">
                  {manufacture?.un?.abbreviation}
                </span>
              </div>

              <div
                className={`addOrRemoveItemBox ${!isPrintEnabled && 'dNone'}`}
              >
                {isLastItem ? (
                  <PlusRoundedIcon
                    onClick={() => {
                      if (isFinished) return;

                      setHasChanged(true);

                      if (!portion?.labelQuantity) {
                        setManufacture({
                          ...manufacture,
                          portions: manufacture?.portions?.map((el, elIndex) =>
                            elIndex === index
                              ? { ...el, invalidField: true }
                              : el
                          )
                        });
                        setModalStates({
                          ...modalStates,
                          modalInvalidQuantity: true
                        });
                        return;
                      }

                      const hashId = GenerateHashId();
                      const newPortions = [
                        ...manufacture?.portions,
                        {
                          quantity: null,
                          labelQuantity: '',
                          printed: false,
                          fakeKey: crypto.randomUUID(),
                          id: hashId
                        }
                      ];

                      setManufacture({ ...manufacture, portions: newPortions });

                      setTimeout(() => {
                        const lastRef =
                          enabledInputRefs.current?.[newPortions.length - 1];
                        if (lastRef) {
                          lastRef.focus();
                          lastRef.select();
                        }
                      }, 50);
                    }}
                    className="switchIcon cursorPointer"
                    size={40}
                    variant="solid"
                    bgColor={isChinaWhiteLabel ? '#E1392EB2' : '#7583F0'}
                    title="Adicionar porção"
                  />
                ) : (
                  <MinusRoundedIcon
                    onClick={() => {
                      if (isFinished) return;
                      setHasChanged(true);
                      enabledInputRefs.current[index] = null;
                      const updatedPortions = manufacture?.portions?.filter(
                        (_, portionIndex) => portionIndex !== index
                      );
                      const totalManufactured = updatedPortions.reduce(
                        (acc, curr) => acc + curr.quantity ?? 0,
                        0
                      );
                      setManufacture({
                        ...manufacture,
                        portions: updatedPortions,
                        manufactured: totalManufactured,
                        manufacturedLabel: totalManufactured
                          ?.toFixed(3)
                          .replace('.', ',')
                      });
                      setTimeout(() => {
                        const refList = enabledInputRefs.current;
                        const lastRef = [...refList]
                          .reverse()
                          .find((el) => el && !el.disabled);
                        if (lastRef) {
                          lastRef.focus();
                          lastRef.select();
                        }
                      }, 50);
                    }}
                    className="switchIcon cursorPointer"
                    size={40}
                    variant="solid"
                    title="Remover porção"
                    bgColor={isChinaWhiteLabel ? '#E5AD5C' : '#F76E79'}
                  />
                )}
              </div>

              <div
                className={`printerBox ${!isPrintEnabled && 'dNone'} ${
                  !portion?.printed && 'visibilityHidden'
                }`}
              >
                <PrinterRoundedIcon
                  onClick={() => {
                    if (loading) return;
                    handlePrintPortion(manufacture, '', [portion]);
                  }}
                  className="switchIcon cursorPointer"
                  size={40}
                  variant={portion?.printed ? 'primary' : 'muted'}
                  bgColor={portion?.printed ? currentLabelColor : undefined}
                  strokeColor={portion?.printed ? '#010311' : undefined}
                  title={
                    portion?.printed
                      ? 'Imprimir etiqueta'
                      : 'Impressão indisponível'
                  }
                />
              </div>
            </div>
          </div>

          {!isLastItem && manufacture?.portions?.length > 1 ? (
            <hr
              style={{
                borderTop: 'solid 1px rgba(146, 150, 172, 1)',
                margin: '10px -10px'
              }}
            />
          ) : null}
        </>
      );
    });

  const renderPausedPopover = () => (
    <Grid
      container
      xs={12}
      justify="center"
      spacing={1}
      style={{ margin: 0, borderRadius: '8px' }}
    >
      <Grid item xs={12} className="mb10">
        <Typography
          className="dFlex flexColumn uppercase textAlignCenter"
          style={{
            fontSize: isMobileScreen ? 20 : 16
          }}
        >
          <span className="uppercase" style={{ fontWeight: 'normal' }}>
            Confirma o reinício da produção da ficha{' '}
          </span>
          <span className="uppercase bold">
            {manufacture ? manufacture.description : null}?
          </span>
        </Typography>
      </Grid>

      <Grid item xs={6} className="dFlex justifyEnd">
        <Button
          design="outlined"
          style={{
            width: isMobileScreen ? '150px' : '40px',
            borderRadius: '12px',
            borderColor: currentLabelColor,
            outline: 0,
            textTransform: 'initial',
            color: currentLabelColor,
            padding: `${isMobileScreen ? '30px' : '20px'} 60px`
          }}
          onClick={handleClose}
          label="CANCELAR"
          color="primary"
        />
      </Grid>

      <Grid
        item
        xs={6}
        className="dFlex justifyStart"
        style={{
          width: '96px'
        }}
      >
        <Button
          className="productionPopupButton white bold"
          disabled={disableSubmitButton}
          style={{
            width: '96px',
            borderRadius: '12px',
            outline: 0,
            textTransform: 'initial',
            padding: `${isMobileScreen ? '30px' : '20px'} 60px`
          }}
          design="contained"
          onClick={() => {
            setDisableSubmitButton(true);

            setTimeout(() => {
              handleUpdate(manufacture, 'START', null, null, null, 'RESTART');
            }, 100);
          }}
          label="CONFIRMAR"
          color="primary"
        />
      </Grid>
    </Grid>
  );

  const renderFinishProductionPopover = () => {
    const totalPortions = isTransformation
      ? manufacture?.items.reduce((acc, item) => {
          const sumItem =
            item.portions?.reduce((sum, p) => sum + (p.quantity || 0), 0) || 0;
          return acc + sumItem;
        }, 0)
      : manufacture?.portions?.reduce(
          (acc, curr) => acc + (curr.quantity ?? 0),
          0
        );

    return (
      <Popover
        id={id}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => {
          hasChanged && handlePrintPortion(manufacture, 'close');

          handleClose();
        }}
        className={`productionPopover ${
          isChinaWhiteLabel && 'chinaProductionPopover'
        }`}
        PaperProps={{
          style: {
            padding: '10px',
            borderRadius: '4px',
            maxWidth: isMobileScreen ? '600px' : '400px'
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <section className="finishPopoverBox">
          <div className="popoverHeader">
            <div className="productionImageBox">
              <ImageWrapper
                width="100%"
                height="40px"
                url={manufacture?.image}
                borderType={manufacture?.type}
              />
            </div>

            <div className="cardTitleBox dFlex flexColumn">
              <span className="uppercase bold">FINALIZAR A PRODUÇÃO?</span>

              <span className="uppercase bold productionDescription">
                {ValidationLength(
                  manufacture?.description || null,
                  isMobileScreen ? 40 : 25
                )}
              </span>
            </div>

            <div className="dateBox">
              <span>DATA:</span>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptLocale}>
                <KeyboardDatePicker
                  size="small"
                  id="finishProductionDate"
                  ampm={false}
                  format="dd/MM"
                  disabled={isFinished}
                  value={moment(cardDate || new Date()).add(3, 'hours')}
                  inputVariant="outlined"
                  className={`dateSmall ${
                    isMobileScreen
                      ? 'childInputFontSize20'
                      : 'childInputFontSize16'
                  }`}
                  onFocus={(e) => {
                    e.currentTarget.select();
                  }}
                  autoOk
                  InputProps={{
                    style: {
                      fontSize: isMobileScreen ? '20px' : '16px',
                      textAlign: 'right'
                    },
                    inputProps: {
                      inputMode: 'numeric'
                    },
                    startAdornment: (
                      <img
                        onClick={() => {
                          calendarButtonRef.current?.click();
                        }}
                        className="switchIcon cursorPointer mr5"
                        src={CalendarIcon}
                        alt="CalendarIcon"
                      />
                    )
                  }}
                  onChange={(date) => {
                    setCardDate(date);
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change time',
                    ref: calendarButtonRef
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>

          <div className="popoverContent">
            {popoverData === 'finishTransformation'
              ? renderFinishTransformationPopover()
              : null}

            {popoverData === 'start' ? renderFinishRecipePopover() : null}

            {popoverData === 'pause' ? renderPausedPopover() : null}
          </div>

          {!isFinished && isPrintEnabled ? (
            <Button
              design="outlined"
              className="keepProducingButton bold"
              onClick={() => {
                if (manufacture?.status === 'PAUSE') {
                  setDisableSubmitButton(true);

                  setTimeout(() => {
                    handleUpdate(
                      manufacture,
                      'START',
                      null,
                      null,
                      null,
                      'RESTART'
                    );
                  }, 100);

                  return;
                }

                hasChanged && handlePrintPortion(manufacture, 'close');

                handleClose();
              }}
              label="IMPRIMIR ETIQUETA(S) E CONTINUAR PRODUZINDO..."
              color="primary"
            />
          ) : null}

          <div className="totalInfosBox">
            <span className="bold">QTDE TOTAL:</span>

            <span className="totalValue">
              {manufacture?.manufacturedLabel ||
                totalPortions?.toFixed(3)?.replace('.', ',') ||
                '0,000'}{' '}
              {manufacture?.un?.abbreviation}
            </span>
          </div>

          {/* {isTransformation && isOutOfValidPercentage().invalid ?
            <>
              <p
                className="requiredWarning ml10 mr10 mb5"
                style={{ fontSize: isMobileScreen ? 20 : 16 }}
              >
                QTDE PRODUZIDA excede em{' '}
                {isOutOfValidPercentage().diffPercentage?.toLocaleString(
                  'pt-br',
                  {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1
                  }
                )}
                % a QTDE do RENDIMENTO ESPERADO, por favor, revise a QTDE
                PRODUZIDA ou a QTDE INICIAL do produto.
              </p>
        
              {currentTransformationCardItems?.items?.every(
                (item) => !item.quantity
              ) && (
                <p
                  className="requiredWarning ml10 mr10 mb5"
                  style={{ fontSize: isMobileScreen ? 20 : 16 }}
                >
                  Por favor preencha ao menos 1 dos itens
                </p>
              )}
            </>
          : null} */}

          {popoverData !== 'pause' && !isFinished ? (
            <div className="mt10 mb10 dFlex">
              <Grid item xs={6} className="dFlex justifyEnd mr20">
                <Button
                  design="outlined"
                  className="productionPopupButton bold"
                  disabled={disableSubmitButton}
                  style={{
                    width: isMobileScreen ? '150px' : '40px',
                    padding: `${isMobileScreen ? '30px' : '20px'} 60px`
                  }}
                  onClick={() => {
                    setDisableSubmitButton(true);

                    if (isTransformation) {
                      setCurrentTransformationCardItems();
                    }

                    setTimeout(() => {
                      handleUpdate(
                        manufacture,
                        'PAUSE',
                        '',
                        '',
                        '',
                        '',
                        manufacture
                      );
                    }, 100);
                  }}
                  label="PAUSAR"
                  color="primary"
                />
              </Grid>

              <Grid item xs={6} className="dFlex justifyStart">
                {isTransformation ? (
                  <Button
                    id="finishPopupButton"
                    className="productionPopupButton bold white"
                    disabled={
                      loading ||
                      disableSubmitButton ||
                      // isOutOfValidPercentage().invalid ||
                      manufacture?.items?.every((item) => !item.quantity)
                    }
                    style={{
                      width: isMobileScreen ? '150px' : '40px',
                      padding: `${isMobileScreen ? '30px' : '20px'} 60px`
                    }}
                    design="contained"
                    onKeyDown={(e) => {
                      if (e.keyCode === 9 || e.keyCode === 13) {
                        const isRetroactive =
                          cardDate &&
                          moment(cardDate)
                            .add(3, 'hours')
                            .format(DATE_FORMAT) !==
                            moment().format(DATE_FORMAT);

                        if (isRetroactive) {
                          setModalSettings(
                            modalSettings.map((modal) =>
                              modal.name === 'modalConfirmationOfFinish'
                                ? {
                                    ...modal,
                                    open: true,
                                    currentManufacture: manufacture
                                  }
                                : modal
                            )
                          );

                          return;
                        }

                        setDisableSubmitButton(true);

                        setTimeout(() => {
                          handleUpdate(manufacture, 'FINISH');
                        }, 200);
                      }
                    }}
                    onClick={(e) => {
                      const isRetroactive =
                        cardDate &&
                        moment(cardDate).add(3, 'hours').format(DATE_FORMAT) !==
                          moment().format(DATE_FORMAT);

                      if (isRetroactive) {
                        setModalSettings(
                          modalSettings.map((modal) =>
                            modal.name === 'modalConfirmationOfFinish'
                              ? {
                                  ...modal,
                                  open: true,
                                  currentManufacture: manufacture
                                }
                              : modal
                          )
                        );

                        return;
                      }

                      setDisableSubmitButton(true);

                      const alreadyPrintedLabels = manufacture?.items
                        ?.map((item) =>
                          item?.portions?.map((portion) => portion?.printed)
                        )
                        .flat()
                        ?.every((el) => el);

                      handlePrintPortion(
                        manufacture,
                        'FINISH',
                        '',
                        alreadyPrintedLabels
                      );
                    }}
                    label="FINALIZAR"
                    color="primary"
                  />
                ) : (
                  <Tooltip
                    title="Insira o valor produzido para finalizar."
                    open={showErrorManufacturedMessage}
                  >
                    <Button
                      id="finishPopupRecipeButton"
                      className="productionPopupButton bold white"
                      disabled={
                        disableSubmitButton ||
                        manufacture?.portions?.every((el) => !el?.quantity)
                      }
                      style={{
                        width: isMobileScreen ? '150px' : '40px',
                        borderRadius: '8px',
                        outline: 0,
                        padding: `${isMobileScreen ? '30px' : '20px'} 60px`,
                        fontSize: '20px'
                      }}
                      design="contained"
                      onClick={(e) => {
                        // deixar essa função desativada.
                        // if(manufacture.lowType === "AUTOMATIC") {
                        //   setModalStates({
                        //     ...modalStates,
                        //     modalAutomaticDown: true
                        //   })
                        //   return;
                        // }
                        const isRetroactive =
                          cardDate &&
                          moment(cardDate)
                            .add(3, 'hours')
                            .format(DATE_FORMAT) !==
                            moment().format(DATE_FORMAT);

                        if (isRetroactive) {
                          setModalSettings(
                            modalSettings.map((modal) =>
                              modal.name === 'modalConfirmationOfFinish'
                                ? {
                                    ...modal,
                                    open: true,
                                    currentManufacture: manufacture
                                  }
                                : modal
                            )
                          );

                          return;
                        }

                        setDisableSubmitButton(true);

                        if (
                          manufacture?.portions?.every((el) => !el?.quantity)
                        ) {
                          setShowErrorManufacturedMessage(true);
                          setManufactures(manufactures);
                          return;
                        }

                        const alreadyPrintedLabels = manufacture?.portions
                          ?.map((portion) => portion?.printed)
                          ?.every((el) => el);

                        handlePrintPortion(
                          manufacture,
                          'FINISH',
                          '',
                          alreadyPrintedLabels
                        );
                      }}
                      label="FINALIZAR"
                      color="primary"
                    />
                  </Tooltip>
                )}
              </Grid>
            </div>
          ) : null}
        </section>
      </Popover>
    );
  };

  const renderProductionQuantityOrYieldField = () => (
    <Popover
      open={productionInputControlPopoverOpen}
      anchorEl={productionInputControlAnchor}
      onClose={() => {
        setProductionInputControlAnchor(null);
        setCurrentCard('');
      }}
      PaperProps={{
        style: {
          padding: '10px',
          borderRadius: '4px',
          maxWidth: '400px',
          marginLeft: 60
        }
      }}
      className="copilotQuantityOrYieldPopover"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      <div className="dFlex alignStart justifyStart flexColumn">
        <div className="dFlex flexColumn popoverCardInfo">
          <span className="fontSizeDefault bold">
            {currentCard?.description}
          </span>

          <span className="fontSizeDefault">
            1 Receita rende{' '}
            {(currentCard?.yield / currentCard?.quantity)?.toLocaleString(
              'pt-br',
              {
                minimumFractionDigits: 3,
                maximunFractionDigits: 3
              }
            )}{' '}
            {currentCard?.un?.abbreviation}
          </span>
        </div>

        <div className="dFlex flexColumn popoverCardActions">
          <FormControl className="dFlex flexRow ml5">
            <FormControlLabel
              value={2}
              control={
                <Radio
                  onChange={() => {
                    handleUpdateViewMethod(2);
                  }}
                  checked={currentCard?.viewMethod === 2}
                  size="small"
                />
              }
              label={<span className="fontSizeDefault bold">Rendimento</span>}
            />
            <FormControlLabel
              value={1}
              control={
                <Radio
                  onChange={() => {
                    handleUpdateViewMethod(1);
                  }}
                  checked={currentCard?.viewMethod === 1}
                  size="small"
                />
              }
              label={<span className="fontSizeDefault bold">Receitas</span>}
            />
          </FormControl>

          <div className="popoverCardValues">
            <span className="fontSizeDefault bold lightBlue">
              {currentCard?.viewMethod === 2
                ? `${currentCard?.yield?.toLocaleString('pt-br', {
                    minimumFractionDigits: 3,
                    maximunFractionDigits: 3
                  })}
                ${currentCard?.un?.abbreviation} = 
                ${currentCard?.quantity?.toLocaleString('pt-br', {
                  minimumFractionDigits: 3,
                  maximunFractionDigits: 3
                })} receitas`
                : `${currentCard?.quantity?.toLocaleString('pt-br', {
                    minimumFractionDigits: 3,
                    maximunFractionDigits: 3
                  })} Receitas = 
                ${currentCard?.yield?.toLocaleString('pt-br', {
                  minimumFractionDigits: 3,
                  maximunFractionDigits: 3
                })} 
                ${currentCard?.un?.abbreviation}`}
            </span>
          </div>
        </div>
      </div>
    </Popover>
  );

  return (
    <>
      {manufacture ? (
        <>
          {renderFinishProductionPopover()}

          {renderTransformationItemPortionsPopover()}
        </>
      ) : null}

      {currentCard ? renderProductionQuantityOrYieldField() : null}
    </>
  );
}

export default ProductionPopovers;
